import { render, staticRenderFns } from "./HkNews.vue?vue&type=template&id=2181d8cd&scoped=true&"
import script from "./HkNews.vue?vue&type=script&lang=js&"
export * from "./HkNews.vue?vue&type=script&lang=js&"
import style0 from "./HkNews.vue?vue&type=style&index=0&id=2181d8cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2181d8cd",
  null
  
)

export default component.exports